<template>
  <div class="pay-fen" data-test="pay-fen">
    <div class="main">
      <div class="ptop">
        <div class="pt1">实收总额</div>
        <div class="pt2">¥{{ totalMoney | formatNumber }}</div>
        <div class="pt3">
          为了准确核算项目收入，请将实收金额全部分解到收费项目中&nbsp;&nbsp;
          <span style="color: var(--tlc)" @click="autoFen">自动分摊</span>
        </div>
      </div>

      <template v-if="list">
        <div class="piwrap" v-for="item in list" :key="item.id">
          <div class="pi">
            <div class="pit">
              <div class="pitl">
                <svg
                  class="vxm-icon"
                  aria-hidden="true"
                  font-size="24"
                  style="margin-right: calc(var(--gap) * 8)"
                  v-if="item.commodityType == 0 || item.commodityType == 1 || item.commodityType == 2"
                >
                  <use xlink:href="#vxm-icon-wupin" v-if="item.commodityType == 0"></use>
                  <use xlink:href="#vxm-icon-banji" v-if="item.commodityType == 1"></use>
                  <use xlink:href="#vxm-icon-kecheng" v-if="item.commodityType == 2"></use>
                </svg>
                <span class="tag" v-if="item.commodityType == 4">课时包</span>
              </div>
              <div class="pitr">
                <div class="tr1 van-ellipsis">
                  <template v-if="item.commodityType == 0">{{
                    app.x3.tool.getGoodsShowName(
                      item.productName,
                      item.priceItemDetail.commodityPriceType,
                      item.priceItemDetail.priceName
                    )
                  }}</template>
                  <template v-if="item.commodityType == 1 || item.commodityType == 4">{{ item.productName }}</template>
                  <template v-if="item.commodityType == 2"
                    >{{ `${item.curriculumName}` }}
                  </template>
                </div>
                <div class="tr2">
                  {{ hasPay ? '应补交金额' : '项目金额' }}：¥{{ item.oweMoney | formatNumber }}
                </div>
              </div>
            </div>

            <div class="pib van-hairline--top">
              <div class="pb1">
                <div>实收金额</div>
                <div class="pibr">
                  <van-field
                    v-model="item.money"
                    type="number"
                    placeholder="请输入金额"
                    :formatter="app.tool.format2MaxWrap(item.oweMoney)"
                  />
                  元
                </div>
              </div>
              <div class="pb2">
                剩余欠交金额：<span style="color: var(--c3)"
                  >¥{{ app.tool.formatFloat(item.oweMoney - item.money, 2) | formatNumber }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="footer">
      <van-button square round block type="primary" @click="submit" data-test="pay-fen-btn-confirm">
        确定
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle: '分摊',
      totalMoney: this.$vxRoute.query.totalMoney,
      hasPay: false,
      list: null,
    };
  },

  methods: {
    prevInit() {
      if (!this.$route.meta._resolve) {
        setTimeout(() => {
          this.$router.back();
        }, 0);
      } else {
        this._resolve = this.$route.meta._resolve;
        this._reject = this.$route.meta._reject;
        this.hasPay = this.$route.meta.hasPay;
        this.list = this.$route.meta.list;
      }
    },
    rsv(ret) {
      this._resolve(ret);
      this.$router.back();
    },
    autoFen() {
      let tMoney = this.totalMoney;
      this.list.forEach(item => {
        if (item.oweMoney < tMoney) {
          item.money = item.oweMoney;
          tMoney = app.tool.formatFloat(tMoney - item.oweMoney, 2);
        } else {
          item.money = tMoney;
          tMoney = 0;
        }
      });
    },
    submit() {
      let tnum = 0;
      this.list.forEach(item => {
        tnum += Number(item.money);
      });
      tnum = app.tool.formatFloat(tnum, 2);
      if (app.tool.formatFloat(tnum, 2) != this.totalMoney) {
        return vant.Toast(
          `实收总额分摊错误（共实收${this.totalMoney}元，实际分摊${tnum}元），请重新分摊。`
        );
      }
      this.rsv(this.list);
    },
  },
  created() {
    this.prevInit();
  },
};
</script>

<style lang="scss" scoped>
.pay-fen {
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow-y: auto;
  }
  .ptop {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: calc(var(--gap) * 24) calc(var(--gap) * 16) calc(var(--gap) * 8);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g6);
    .pt2 {
      padding-top: calc(var(--gap) * 12);
      padding-bottom: calc(var(--gap) * 32);
      font-size: 36px;
      line-height: 42px;
      font-weight: var(--bold);
      color: var(--g8);
    }
  }
  .piwrap {
    padding-bottom: calc(var(--gap) * 12);
    .pi {
      background: var(--white);
      .pit {
        display: flex;
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
        .pitl {
          .tag {
            background: var(--c1);
            color: #fff;
            margin-right: calc(var(--gap) * 8);
            padding: calc(var(--gap) * 2);
          }
        }
        .pitr {
          flex: 1;
          overflow: hidden;
          padding-top: calc(var(--gap) * 1);
          .tr1 {
            font-size: var(--fs-lg);
            line-height: var(--lh-lg);
            font-weight: var(--bold);
            color: var(--g8);
          }
          .tr2 {
            padding-top: calc(var(--gap) * 8);
            font-size: var(--fs-md);
            line-height: var(--lh-md);
            color: var(--g6);
          }
        }
      }
      .pib {
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
        color: var(--g7);
        .pb1 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .pibr {
            display: flex;
            align-items: center;
            ::v-deep .van-cell {
              padding: 0;
              margin-right: calc(var(--gap) * 8);
              text-align: center;
              // background: var(--g2);
              // border-radius: 4px;
              .van-field__body {
                // width: 100px;
                // height: 28px;
                // line-height: 28px;
                // padding: 0 calc(var(--gap) * 12);
                .van-field__control {
                  text-align: right;
                }
              }
            }
          }
        }
        .pb2 {
          padding-top: calc(var(--gap) * 6);
          text-align: right;
          color: var(--g6);
        }
      }
    }
  }

  .footer {
    padding: calc(var(--gap) * 4) calc(var(--gap) * 16);
    background: var(--white);
  }
}
</style>